import { render, staticRenderFns } from "./WallBody.vue?vue&type=template&id=fddbc784&scoped=true&"
import script from "./WallBody.vue?vue&type=script&lang=js&"
export * from "./WallBody.vue?vue&type=script&lang=js&"
import style0 from "./WallBody.vue?vue&type=style&index=0&id=fddbc784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddbc784",
  null
  
)

export default component.exports